import { useEffect, useState } from "react"
import { Spinner } from "reactstrap"

let subscriber = null

function subscribe(fn) {
  subscriber = { fn }
}

function unsubscribe() {
  subscriber = null
}

export function showLoading() {
  if (subscriber)
    subscriber.fn(true)
}

export function hideLoading() {
  if (subscriber)
    subscriber.fn(false)
}

export default function Loading() {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    subscribe(setIsVisible)
    return () => {
      unsubscribe()
    }
  })

  if (!isVisible) {
    return null
  }

  return (
    <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center text-white" style={{ zIndex: 9999, background: '#000B' }}>
      <Spinner />
    </div>
  )
}